export default "__VITE_ASSET__CemcAo$E__"